<template>
  <v-bottom-navigation :value="true" style="position: fixed; bottom: 0">
    <v-row>
      <v-spacer />
      <v-card-title class="mr-4" v-if="$vuetify.breakpoint.smAndUp">
        <small>
          {{ $t("components.profile.EditProfileDialog.saveQuestion") }}
        </small>
      </v-card-title>
      <v-btn
        class="navigationbottombutton navigationbottomReject mt-5 mr-2"
        :loading="isLoading"
        outlined
        large
        color="warning"
        @click="abort"
        data-test-profile-abort
      >
        {{ $t("components.profile.EditProfileDialog.abort") }}
      </v-btn>
      <v-btn
        class="navigationbottombutton navigationbottomConfirm mt-5 mr-10"
        :disabled="!valid"
        :loading="isLoading"
        color="primary"
        @click="save"
        data-test-profile-submit
        x-large
      >
        {{ $t("components.profile.EditProfileDialog.save") }}
      </v-btn>
    </v-row>
  </v-bottom-navigation>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import ProfileFormFields from "./ProfileFormFields.vue";

@Component({
  components: { ProfileFormFields }
})
export default class ProfileConfirmationRow extends DarkModeHighlightMixin {
  @Prop()
  isLoading!: boolean;

  @Prop()
  valid!: boolean;

  save() {
    this.$emit("save");
  }

  abort() {
    this.$emit("abort");
  }
}
</script>

<style scoped>
.navigationbottombutton {
  align-items: center !important;
  border-radius: 4px !important;
  display: inline-flex;
  flex: 0 0 auto !important;
  font-weight: 500 !important;
  letter-spacing: 0.0892857143em !important;
  justify-content: center !important;
  outline: 0 !important;
  text-decoration: none !important;
  text-indent: 0.0892857143em !important;
  text-transform: uppercase !important;
  transition-duration: 0.28s !important;
  transition-property: box-shadow, transform, opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  color: white !important;
  height: 40px !important;
}
.navigationbottomReject {
  font-size: 1rem !important;
}
.navigationbottomConfirm {
  font-size: 1.125rem !important;
}
</style>
